<template>
  <div class="timeline-wrapper">
    <h2 class="section-title">发展历程</h2>
    <div class="horizontal-timeline">
      <!-- 左右切换箭头 -->
      <button class="timeline-arrow timeline-arrow-left" @click="prevYear" aria-label="上一年">
        <i class="fa fa-chevron-left"></i>
      </button>
      
      <!-- 中间内容区域 -->
      <div class="timeline-content-area">
        <div class="timeline-background-year">{{ currentItem.time }}</div>
        <div class="timeline-content">
          <h3 class="timeline-content-title">{{ currentItem.title }}</h3>
          <p class="timeline-content-desc">{{ currentItem.desc }}</p>
        </div>
      </div>
      
      <button class="timeline-arrow timeline-arrow-right" @click="nextYear" aria-label="下一年">
        <i class="fa fa-chevron-right"></i>
      </button>
      
      <!-- 下方时间线 -->
      <div class="timeline-line-container">
        <div class="timeline-line"></div>
        <div class="timeline-year-markers">
          <div 
            v-for="(item, idx) in items" 
            :key="idx" 
            class="timeline-year-marker"
            :class="{ active: idx === currentIndex }"
            @click="setCurrentYear(idx)"
          >
            <div class="year-dot" :style="{ backgroundColor: idx === currentIndex ? item.color : '#ccc' }"></div>
            <div class="year-text" :style="{ color: idx === currentIndex ? item.color : '#999' }">{{ item.time }}年</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TimelineSection',
  props: { data: { type: Array, default: () => [] } },
  computed: { 
    items() { 
      return this.data.length ? this.data : this.defaultData 
    },
    currentItem() {
      return this.items[this.currentIndex]
    }
  },
  data() {
    return {
      currentIndex: 0,
      defaultData: [
        { time: '2009', title: '早期探索', desc: '团队创始成员开始量化与程序化交易研究。', color: '#409eff' },
        { time: '2015', title: '策略体系成型', desc: '多因子 + 事件驱动策略矩阵建立。', color: '#67c23a' },
        { time: '2019', title: '技术平台升级', desc: '引入分布式回测与实时风险监控。', color: '#e6a23c' },
        { time: '2022', title: '研究院成立', desc: '中政量化技术研究院正式成立。', color: '#f56c6c' },
        { time: '2024', title: '智能化深化', desc: 'AI 因子、LLM 辅助研究流程上线。', color: '#909399' },
        { time: '2025', title: '多策略上线实盘运行', desc: '收益显著', color: '#409eff' }
      ]
    }
  },
  methods: {
    prevYear() {
      this.currentIndex = (this.currentIndex - 1 + this.items.length) % this.items.length
    },
    nextYear() {
      this.currentIndex = (this.currentIndex + 1) % this.items.length
    },
    setCurrentYear(index) {
      this.currentIndex = index
    }
  }
}
</script>
<style scoped>
.timeline-wrapper { 
  margin: 80px 0; 
  padding: 0 40px;
}

.section-title { 
  text-align: center; 
  margin-bottom: 60px; 
  font-size: 24px; 
  font-weight: 500; 
  color: #333;
  position: relative;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 2px;
  background: #333;
}

/* 横向时间线样式 */
.horizontal-timeline {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  padding: 40px 0;
}

/* 左右箭头 */
.timeline-arrow {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #e0e0e0;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;
  color: #999;
  transition: all 0.3s ease;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 3;
}

.timeline-arrow:hover {
  border-color: #409eff;
  color: #409eff;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
}

.timeline-arrow-left {
  left: 20px;
}

.timeline-arrow-right {
  right: 20px;
}

/* 中间内容区域 */
.timeline-content-area {
  position: relative;
  text-align: center;
  padding: 0 60px;
  flex: 1;
  max-width: 800px;
}

.timeline-background-year {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 120px;
  font-weight: 100;
  color: rgba(0, 0, 0, 0.05);
  z-index: 1;
  pointer-events: none;
}

.timeline-content {
  position: relative;
  z-index: 2;
  padding: 40px 0;
}

.timeline-content-title {
  font-size: 18px;
  font-weight: 500;
  color: #333;
  margin: 0 0 10px;
}

.timeline-content-desc {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
  margin: 0;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

/* 下方时间线 */
.timeline-line-container {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0 20px;
}

.timeline-line {
  height: 1px;
  background: #e0e0e0;
  margin: 0 auto;
  position: relative;
}

.timeline-year-markers {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  top: 10px;
  padding: 0 10px;
  gap: 20px;
  /* allow horizontal scrolling on small screens */
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.timeline-year-marker {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.timeline-year-marker {
  min-width: 56px;
}

.year-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #ccc;
  margin-bottom: 8px;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.timeline-year-marker.active .year-dot {
  background: #409eff;
  transform: scale(1.2);
}

.year-text {
  font-size: 14px;
  color: #999;
  transition: all 0.3s ease;
}

.timeline-year-marker.active .year-text {
  color: #409eff;
  font-weight: 500;
}

.timeline-year-marker:hover .year-dot {
  background: #409eff;
  opacity: 0.8;
}

.timeline-year-marker:hover .year-text {
  color: #409eff;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .timeline-wrapper {
    padding: 0 20px;
  }
  
  .timeline-background-year {
    font-size: 100px;
  }
  
  .timeline-year-markers {
    padding: 0 5px;
  }
  
  .year-text {
    font-size: 12px;
  }
}

@media (max-width: 992px) {
  .timeline-background-year {
    font-size: 80px;
  }
  
  .timeline-content-title {
    font-size: 16px;
  }
  
  .timeline-content-desc {
    font-size: 14px;
  }
  
  .timeline-year-markers {
    /* prefer a single-row scrollable list on narrower screens */
    flex-wrap: nowrap;
    gap: 16px;
    justify-content: flex-start;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  
  .timeline-year-marker {
    flex: 0 0 auto;
    margin: 0 6px;
    min-width: 72px;
    justify-content: center;
  }
}

@media (max-width: 768px) {
  .timeline-wrapper {
    margin: 60px 0;
    padding: 0 10px;
  }
  
  .section-title {
    font-size: 20px;
    margin-bottom: 40px;
  }
  
  .horizontal-timeline {
    min-height: 250px;
    padding: 20px 0;
  }
  
  .timeline-arrow {
    width: 32px;
    height: 32px;
    font-size: 12px;
  }
  
  .timeline-arrow-left {
    left: 10px;
  }
  
  .timeline-arrow-right {
    right: 10px;
  }
  
  .timeline-content-area {
    padding: 0 20px;
    max-width: 100%;
  }
  
  .timeline-background-year {
    font-size: 48px;
  }
  
  .timeline-content {
    padding: 20px 0;
  }
  
  .timeline-content-title {
    font-size: 14px;
  }
  
  .timeline-content-desc {
    font-size: 13px;
  }
  
  .timeline-year-markers {
    gap: 12px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  
  .year-text {
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  /* On very small screens, show markers as a horizontal scroll list with compact markers */
  .timeline-year-markers {
    flex-direction: row;
    align-items: center;
    gap: 12px;
    padding: 6px 8px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    justify-content: flex-start;
  }

  .timeline-year-marker {
    flex-direction: column;
    min-width: 64px;
    gap: 6px;
    padding: 6px 4px;
  }

  .year-dot {
    margin-bottom: 6px;
  }

  .timeline-background-year {
    display: none;
  }

  .timeline-content-desc {
    max-width: 280px;
    margin-left: auto;
    margin-right: auto;
  }

  /* hide default scrollbar visual on webkit browsers for a cleaner look */
  .timeline-year-markers::-webkit-scrollbar { height: 6px; }
  .timeline-year-markers::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.08); border-radius: 3px; }
}
</style>
